<div class="drag-area">
  <div class="icon">
    <i class="fas fa-cloud-upload-alt"></i>
  </div>
  <header *ngIf="!files"> {{ 'fileInput.dragDropInstruction' | translate }}</header>
  <header *ngIf="files"> {{ 'fileInput.filesSelected' | translate }}
    <div *ngFor="let file of files">
      {{ file.name }}
    </div>
  </header>
  <div class="mt-2"></div>
  <button class="btn btn-primary" [disabled]="disabled"
          (click)="this.triggerClick()">
    {{ 'fileInput.browseFiles' | translate }}
  </button>
  <input [id]="inputId"
         class="input-hidden"
         [multiple]="multiple"
         [disabled]="disabled"
         (change)="this.onFileChange($event)"
         type="file"
         hidden/>
</div>
